import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getServerModals } from "./server-modals";

export const serverModalsQueriesStore = createQueryKeys("server-modals", {
  list: {
    queryKey: null,
    queryFn: getServerModals,
  },
});
